import { Box, Flex } from '@chakra-ui/react'
import Image from 'next/image'

interface Item {
  ratio: number
  imageUrl: string
  className?: string
}

interface BeifitMobileProps {
  items: Item[]
  isOne?: boolean
}

const BenefitMobile = (props: BeifitMobileProps) => {
  return (
    <Flex direction="column">
      {props.items.map((item, index) => (
        <Box
          key={index}
          h={{
            base: props.isOne ? '320px' : '100px'
          }}
          w="auto"
        >
          <Box
            h="100%"
            w="auto"
            style={{
              aspectRatio: `${item.ratio}`
            }}
            position="relative"
            className={item.className}
          >
            <Image src={item.imageUrl} alt="benifit" fill />
          </Box>
        </Box>
      ))}
    </Flex>
  )
}

export default BenefitMobile
